import { useEffect, useState } from "react";
import { auth, db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";

export default function Calendar({ onSelectDate, selectedDate }) {
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [journalDates, setJournalDates] = useState(new Set());

  const user = auth.currentUser;

  useEffect(() => {
    if (!user) return;

    // Učitaj sve datume koji imaju journal zapise
    const journalRef = collection(db, "users", user.uid, "journal");
    getDocs(journalRef).then((snapshot) => {
      const dates = new Set();
      snapshot.forEach((doc) => {
        dates.add(doc.id); // doc.id je YYYY-MM-DD
      });
      setJournalDates(dates);
    });
  }, [user]);

  const today = new Date().toISOString().split("T")[0];

  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDay = firstDay.getDay(); // 0 = Sunday

    const days = [];

    // Praznine pre prvog dana
    for (let i = 0; i < startingDay; i++) {
      days.push(null);
    }

    // Dani u mesecu
    for (let day = 1; day <= daysInMonth; day++) {
      const dateStr = `${year}-${String(month + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
      days.push({
        day,
        dateStr,
        isToday: dateStr === today,
        hasJournal: journalDates.has(dateStr),
        isSelected: dateStr === selectedDate
      });
    }

    return days;
  };

  const prevMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1));
  };

  const nextMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1));
  };

  const goToToday = () => {
    setCurrentMonth(new Date());
    onSelectDate(today);
  };

  const monthNames = [
    "Januar", "Februar", "Mart", "April", "Maj", "Jun",
    "Jul", "Avgust", "Septembar", "Oktobar", "Novembar", "Decembar"
  ];

  const dayNames = ["Ned", "Pon", "Uto", "Sre", "Čet", "Pet", "Sub"];

  const days = getDaysInMonth(currentMonth);

  return (
    <div className="calendar-container">
      <div className="calendar-header">
        <button onClick={prevMonth}>←</button>
        <h2>{monthNames[currentMonth.getMonth()]} {currentMonth.getFullYear()}</h2>
        <button onClick={nextMonth}>→</button>
      </div>

      <button className="today-button" onClick={goToToday}>
        📅 Idi na danas
      </button>

      <div className="calendar-grid">
        {dayNames.map((name) => (
          <div key={name} className="calendar-day-name">
            {name}
          </div>
        ))}

        {days.map((dayInfo, index) => (
          <div
            key={index}
            className={`calendar-day ${!dayInfo ? "empty" : ""} ${dayInfo?.isToday ? "today" : ""} ${dayInfo?.hasJournal ? "has-journal" : ""} ${dayInfo?.isSelected ? "selected" : ""}`}
            onClick={() => dayInfo && onSelectDate(dayInfo.dateStr)}
          >
            {dayInfo?.day}
          </div>
        ))}
      </div>

      <div className="calendar-legend">
        <span><span className="legend-dot today-dot"></span> Danas</span>
        <span><span className="legend-dot journal-dot"></span> Ima zapis</span>
      </div>
    </div>
  );
}
